import { colors } from "@biblioteksentralen/utils";
import { defaultConfig, defineRecipe, SystemStyleObject } from "@chakra-ui/react";

export type CustomButtonVariants = "primary" | "secondary" | "tertiary";

const variants: Record<CustomButtonVariants, SystemStyleObject> = {
  primary: {
    backgroundColor: colors.black,
    color: "white",
    _hover: {
      backgroundColor: "hsla(0deg, 0%, 70%, 1)",
      color: "black",
    },
  },
  secondary: {
    borderColor: "currentColor",
    color: "currentColor",
    backgroundColor: "transparent",
    _hover: {
      backgroundColor: "currentColor/7",
    },
  },
  tertiary: {
    color: "currentColor",
    backgroundColor: "transparent",
    _hover: {
      backgroundColor: "currentColor/7",
    },
  },
  // Inherit variants from Chakra's default config. Seems like they are overridden by our custom variants by default.
  ...defaultConfig.theme?.recipes?.button?.variants?.variant,
};

export const ButtonStyles = defineRecipe({
  base: {
    borderColor: "transparent",
    borderWidth: "0.1em",
    fontWeight: 600,
    _disabled: {
      backgroundColor: `${colors.grey45}`,
      color: "white",
      opacity: 1,
    },
  },
  variants: {
    variant: variants,
    size: {
      sm: {
        h: "8",
        px: "2",
        textStyle: "md",
      },
      md: {
        textStyle: "md",
      },
      lg: {
        h: "12",
        textStyle: "lg",
      },
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "md",
  },
});
